var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6639_35485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9601 35.628C42.9601 35.628 46.0861 36.252 51.4321 34.512C54.1501 33.624 55.9021 31.458 56.9701 29.538C57.4441 28.692 56.5261 27.744 55.662 28.182C54.036 29.01 52.7461 29.856 48.9241 30.288C40.0981 31.284 38.1061 23.076 38.1061 23.076L34.1281 31.53L42.954 35.634L42.9601 35.628Z",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.644 16.488C28.644 16.488 17.472 30.966 5.27401 30.03C4.09801 29.94 3.60601 31.494 4.59001 32.13C6.02401 33.06 8.10001 33.816 10.968 33.624C17.682 33.18 23.922 27.15 23.922 27.15L28.638 16.482L28.644 16.488Z",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.442 9.29398C37.152 10.77 35.466 11.838 33.582 12.378C31.716 12.918 28.77 15.102 27.546 16.728C25.476 19.482 17.574 38.214 4.47003 38.496C3.05403 38.526 2.36403 40.254 3.38403 41.238C5.01603 42.804 7.60203 44.34 11.388 44.076C17.664 43.638 21.81 40.824 23.82 38.856C27.36 35.376 31.152 27.666 31.152 27.666C31.152 27.666 29.538 38.604 33.762 42.084C37.152 44.874 41.982 49.26 44.208 52.602C44.856 53.568 46.356 53.274 46.614 52.14C47.268 49.236 47.184 42.474 42.96 35.622C37.014 25.98 37.83 19.812 38.304 17.946C38.406 17.532 38.49 17.106 38.544 16.68C38.67 15.666 39.582 13.578 39.984 12.84L38.448 9.28798",
    fill: "#FEDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.442 9.29398C37.152 10.77 35.466 11.838 33.582 12.378C31.716 12.918 28.77 15.102 27.546 16.728C25.476 19.482 17.574 38.214 4.47003 38.496C3.05403 38.526 2.36403 40.254 3.38403 41.238C5.01603 42.804 7.60203 44.34 11.388 44.076C17.664 43.638 21.81 40.824 23.82 38.856C27.36 35.376 31.152 27.666 31.152 27.666C31.152 27.666 29.538 38.604 33.762 42.084C37.152 44.874 41.982 49.26 44.208 52.602C44.856 53.568 46.356 53.274 46.614 52.14C47.268 49.236 47.184 42.474 42.96 35.622C37.014 25.98 37.83 19.812 38.304 17.946C38.406 17.532 38.49 17.106 38.544 16.68C38.67 15.666 39.582 13.578 39.984 12.84L38.448 9.28798",
    stroke: "#FEDC5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.442 9.29398C39.528 8.05198 40.71 6.80998 41.082 6.80998C41.826 6.80998 45.684 7.55398 44.934 8.42398C44.436 8.99998 42.132 9.85198 40.566 11.928C39.876 12.84 37.146 10.77 38.436 9.29398H38.442Z",
    fill: "#E0BF53",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6639_35485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.07cafd9d2cdb5c2ac8928226aeb8defd.svg";
export { ForwardRef as ReactComponent };